<template>
  <v-data-table
    :headers="headers"
    :items="tableData"
    :loading="loading"
    :options.sync="options"
    :server-items-length="totalCount"
    >
    <template #[`item.build.created_at`]="{item}">
        <v-chip
          dark
          small
          :color="getServiceLevelColor(item.build.serviceLevel)"
        >{{ item.build.serviceLevel }} day(s)</v-chip>
    </template>
    <template #[`item.actions`]="{item}">
        <v-btn icon @click="open(item.id)">
          <v-icon>mdi-dots-horizontal</v-icon>
        </v-btn>
    </template>
    <template #[`item.buildStatus`]="{item}">
        {{(item.prescription)?item.prescription.statusId:'Not a prescription'}}
    </template>

  </v-data-table>
</template>

<script>
import _ from "lodash";
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      tableData: [],
      totalCount: 0,
      loading: null,
      options: { sortBy:['created_at'], sortDesc:[true],rowsPerPage: 15 },
      
    };
  },
  props: {
    status: {
      type: String
    }
  },
  computed:{
    headers () {
      return [
        ... this.status =='pending' ? [{text: "PendingBox", value: "build.pendingBox.name", sortable:false}] : [],
        {text: "Order Id", value: "build.order_id", align:"right"},
        {text: "Customer", value: "build.client.displayName", sortable:false },
        {text: "Shop", value: "build.shop.name", sortable:false},
        {text: "Status", value: "status_id", bgcolor: null,sortable:false },
        {text: "Builder", value: "build.builder.displayName", bgcolor: null,sortable:false },
        {text: "Service Level", value: "build.created_at"},
        {text: "Actions", value: "actions", sortable:false}
      ]
    }
  },
  mounted: function() {
    this.getBuilds();
  },
  watch: {
    options: {
      handler: _.debounce(function() {
        this.getBuilds();
      }, 100)
    }
  },
  methods: {
    ...mapActions("handling",["list"]),
    getBuilds() {
      this.loading = true;
      this.list({
          pagination: this.options,
          rows_per_page: this.options.rowsPerPage,
          search: this.search,
          filters: {status_id:this.status},
          expand: "prescription"
        })
        .then(({handlings}) => {
          this.tableData = handlings.data;
          this.totalCount = handlings.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    open(id) {
      this.$router.push("/build/handling/" + id);
    },
    getServiceLevelColor(sl) {
      if (sl > 20) {
        return "red";
      }
      if (sl > 10) {
        return "orange";
      }
      if (sl > 0) {
        return "green";
      }
    },
  }
};
</script>
<style>

</style>